function reorderPDF(pdfDoc, newOrder) {
  const pages = pdfDoc.getPages()
  for (let currentPage = 0; currentPage < newOrder.length; currentPage++) {
    pdfDoc.removePage(currentPage)
    pdfDoc.insertPage(currentPage, pages[newOrder[currentPage] - 1])
  }
}

export default reorderPDF
